<div class="app-layout">
  <lib-live-pickup-status-bar
    [waitingInQueue]="store.waitingCount()"
    [lastUpdate]="store.lastUpdate()"
    [systemStatus]="store.systemStatus()"
    [portao]="store.accessPointName()"
    [accessPoints]="gateOptions()"
    [selectedAccessPointId]="store.accessPointId()"
    (accessPointChange)="onAccessPointChange($event)"
  />
  <main class="app-content custom-scrollbar">
    @let hero = store.heroStudent();
    @if (!hideHeroOnMobile()) {
      <!-- TODO(live-pickup): reativar [turma]="hero?.className ?? ''" quando o backend enviar StudentClassDisplay. -->
      <lib-live-pickup-hero-section
        [studentName]="hero?.name ?? ''"
        [personId]="hero?.studentPersonId ?? ''"
        [portao]="hero?.gate ?? ''"
        [responsavel]="hero?.responsibleName ?? ''"
        [reconhecimentoTime]="hero?.recognizedOnUtc ?? ''"
        [displayType]="hero?.displayType ?? 'recognized'"
        [heroId]="hero?.id ?? ''"
        [waitingCount]="store.waitingCount()"
        [completedTodayCount]="store.completedRequests().length"
      />
    }
    <router-outlet></router-outlet>
  </main>
</div>
